import { graphql } from '@mp/graphql/generated';
import { useCurrentUser } from '@mp/hooks';
import { useGraphQLQuery } from '@mp/hooks/useGraphQLRequest';
import { type ResultOf } from '@graphql-typed-document-node/core';

export const AssignmentRequestsGql = graphql(`
  query GetAssignmentRequestsForAssignmentGeneralInfo($input: AssignmentRequestQueryInput) {
    assignmentRequests(input: $input) {
      id
      status
    }
  }
`);

type AssignmentRequests = ResultOf<typeof AssignmentRequestsGql>;

export const useAssignmentRequestsForAssignmentGeneralInfo = (
  options: { assignment_id?: number } = {},
) => {
  const { currentUser } = useCurrentUser();
  const enabled = options.assignment_id === undefined ? true : !!options.assignment_id;

  const { data, isLoading } = useGraphQLQuery<AssignmentRequests>({
    operationName: 'GetAssignmentRequestsForEducation',
    query: AssignmentRequestsGql,
    variables: {
      input: { filter: { assignment_id: options.assignment_id }, orderBy: { updated_at: false } },
      professional_id: currentUser?.professional?.id,
    },
    enabled,
  });
  const assignmentRequests = data?.assignmentRequests || [];

  return { assignmentRequests, isLoading };
};
